import * as React from 'react';
import moment from 'moment-timezone';
import { Reservable } from '../../../../commonv3/types/reservable';
import classNames from 'classnames';
import './scheduleListItem.module.scss';
import { SessionParameter, SessionParameterKey } from '../../../types/sessions';

type BadgeProps = {
    color: 'pink';
    children: any;
};
export const ScheduleBadge = ({ color, children }: BadgeProps) => (
    <span styleName={classNames('schedule-badge', color)}>{children}</span>
);

type Props = {
    id?: string;
    title?: string;
    reservable: Reservable;
    actionItem?: any;
    masked?: boolean;
    maskMessage?: any;
    titleBadge?: any;
};

export function parseSessionLabels(params: SessionParameter[]): string[] {
    if (!params) {
        return [];
    }
    const labelParam = params.find((p) => p.key === SessionParameterKey.LABELS);
    if (labelParam) {
        return labelParam.value.split(/,\s*/).filter((s) => !!s);
    }
    return [];
}

export class ScheduleListItem extends React.Component<Props> {
    render() {
        const {
            id,
            title,
            reservable,
            actionItem,
            masked = false,
            maskMessage = '',
            titleBadge = undefined,
        } = this.props;
        const {
            starts_at,
            ends_at,
            capacity,
            active_reservation_count,
            location,
            params,
            coach_positions,
        } = reservable;
        const labels = parseSessionLabels(params);

        return (
            <div id={id || `schedule-list-item-${reservable.id}`} styleName="schedule-list-item">
                {title && (
                    <div styleName="title">
                        {title}
                        {titleBadge && <span styleName="badge-wrapper">{titleBadge}</span>}
                    </div>
                )}
                <div styleName="label">
                    {labels.length !== 0 &&
                        labels.map((label, index) => (
                            <div key={index} styleName="label-item">
                                <ScheduleBadge color="pink">{label}</ScheduleBadge>
                            </div>
                        ))}
                </div>
                <div styleName="main">
                    <div styleName="header">
                        <div styleName="time">
                            時間: {moment(starts_at).format('HH:mm')}
                            &nbsp;-&nbsp;
                            {moment(ends_at).format('HH:mm')}
                        </div>
                        <div styleName="location-capacity">
                            <div styleName="location">
                                場所: {location ? location.short_name || location.name : 'オンライン'}
                            </div>
                            <div styleName="capacity">
                                申込者: {active_reservation_count}/{capacity}人
                            </div>
                        </div>
                        <div>
                            {coach_positions && (
                                <div styleName="coaches">
                                    <div>TA:</div>

                                    <div styleName="coach_names">
                                        {coach_positions.length > 0
                                            ? coach_positions.map((c) => c.user_name).join('、')
                                            : '未定'}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div styleName="action">{actionItem}</div>
                </div>
                {masked && (
                    <div id={`mask-${reservable.id}`} styleName="mask">
                        {maskMessage}
                    </div>
                )}
            </div>
        );
    }
}
